import { Mutation, Action, VuexModule, getModule, Module } from 'vuex-module-decorators';
import { RootState, store } from '../..';

export interface IHomeModule {
  currentPage: number;
}
@Module({ dynamic: true, store, name: 'homeModule', namespaced: true })
class HomeModule extends VuexModule implements IHomeModule {
  currentPage: number = 1;

  @Mutation
  setCurrentPage(value: number) {
    this.currentPage = value;
  }
}

export const homeModule = getModule(HomeModule);
